import { getCurrentPointsEpoch, getPointsEpochBlockRange } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { usePublicClient } from "wagmi";

export const useEpoch = () => {
    const publicClient = usePublicClient();

    const { data: currentBlock } = useQuery({
        queryKey: ["currentBlock"],
        queryFn: async () => {
            if (!publicClient) return null;
            const blockNumber = await publicClient.getBlockNumber();

            return Number(blockNumber);
        },
        enabled: !!publicClient,
        refetchInterval: 12_000, // Refetch every 12 seconds~ eth block time
    });

    // Calculate current epoch and block range based on current block
    const epochData = useMemo(() => {
        if (!currentBlock) return null;

        const currentEpoch = Math.floor(getCurrentPointsEpoch(currentBlock));
        const { start: startBlock, end: endBlock } = getPointsEpochBlockRange(currentEpoch);

        return {
            currentEpoch,
            startBlock,
            endBlock,
        };
    }, [currentBlock]);

    return {
        currentBlock,
        ...epochData,
    };
};
